import { Component } from '@angular/core';

@Component({
  selector: 'app-badge',
  standalone: true,
  imports: [],
  templateUrl: './badge.component.html',
  styles: ``,
  host: {
    class:
      'inline-flex rounded-full h-[20px] px-1 min-w-[20px]  text-white ml-1 flex items-center justify-center text-xs',
  },
})
export class BadgeComponent {}
